// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__4N5oA","header":"styles_header__yDKmB","text":"styles_text__4osH8","functionLayout":"styles_functionLayout__6j_WU"};